import { CvSearchOption, DriverLicense, EducationStatus, QualificationStatus } from '../../../../api-service/clients';
import { zipCodes } from '../../../../utilities';

export interface CvSearchState {
  occupations: CvSearchOption[];
  qualifications: CvSearchOption[];
  educations: CvSearchOption[];
  languages: CvSearchOption[];
  cities: CvSearchCity[];

  numberOfKm: number;
  selectedOccupations: CvSearchOption[];
  selectedQualifications: CvSearchOption[];

  freetextSearch?: string;
  selectedFreeTextOccupations: CvSearchOption[];
  selectedFreeTextQualifications: CvSearchOption[];
  selectedFreeTextEducations: CvSearchOption[];

  selectedLanguages: CvSearchOption[];
  selectedDriversLicenses: DriverLicensesType[];
  selectedCity?: CvSearchCity;

  showOnlyJobReady: boolean;
  showOnlyFlexjobVisitated: boolean;
  showOnlyJobcenter: boolean;
  qualificationStatus: QualificationStatus;
  educationStatus: EducationStatus;
}

export enum WithOrWithoutState {
  With = 'with',
  Without = 'without',
}

export interface CvResult {
  citizenName: string;
  cvFile: string;
  jobWishes: string[];
  educations: string[];
  residence: string;
  cvSearchable: boolean;
  municipality: string;
}

export interface CvSearchCity {
  name: string;
  zipCode: string;
}

export function getCities(): CvSearchCity[] {
  return zipCodes.map(x => ({ name: x.city, zipCode: x.zipCode }));
}

export function getQualificationStatus(qualificationState?: WithOrWithoutState): QualificationStatus {
  if (!qualificationState) {
    return QualificationStatus.NotSpecified;
  }
  return qualificationState === WithOrWithoutState.With ? QualificationStatus.With : QualificationStatus.Without;
}

// Driverslicense
export enum DriverLicensesType {
  LK = '1',
  AM = '2',
  A1 = '3',
  A2 = '4',
  A = '5',
  B = '6',
  BE = '7',
  C1 = '8',
  C1E = '9',
  C = '10',
  CE = '11',
  D1 = '12',
  D1E = '13',
  D = '14',
  DE = '15',
  TM = '16',
}

export const driverLicencesTypes = [
  DriverLicensesType.LK,
  DriverLicensesType.AM,
  DriverLicensesType.A1,
  DriverLicensesType.A2,
  DriverLicensesType.A,
  DriverLicensesType.B,
  DriverLicensesType.BE,
  DriverLicensesType.C1,
  DriverLicensesType.C1E,
  DriverLicensesType.C,
  DriverLicensesType.CE,
  DriverLicensesType.D1,
  DriverLicensesType.D1E,
  DriverLicensesType.D,
  DriverLicensesType.DE,
  DriverLicensesType.TM,
];

export function getDriverLicencesType(type: DriverLicensesType) {
  switch (type) {
    case DriverLicensesType.LK:
      return 'LK - Lille knallert';
    case DriverLicensesType.AM:
      return 'AM - Stor knallert';
    case DriverLicensesType.A1:
      return 'A1 - Lille motorcykel';
    case DriverLicensesType.A2:
      return 'A2 - Mellemstor motorcykel';
    case DriverLicensesType.A:
      return 'A - Stor motorcykel';
    case DriverLicensesType.B:
      return 'B - Almindelig bil';
    case DriverLicensesType.BE:
      return 'BE - Almindelig bil med stort påhængskøretøj';
    case DriverLicensesType.C1:
      return 'C1 - Lille lastbil';
    case DriverLicensesType.C1E:
      return 'C1E - Lille lastbil med stort påhængskøretøj';
    case DriverLicensesType.C:
      return 'C - Stor lastbil';
    case DriverLicensesType.CE:
      return 'CE - Stor lastbil med stort påhængskøretøj';
    case DriverLicensesType.D1:
      return 'D1 - Lille bus';
    case DriverLicensesType.D1E:
      return 'D1E - Lille bus med stort påhængskøretøj';
    case DriverLicensesType.D:
      return 'D - Stor bus';
    case DriverLicensesType.DE:
      return 'DE - Stor bus med stort påhængskøretøj';
    case DriverLicensesType.TM:
      return 'TM - Traktor og motorredskab';
    default:
      return '';
  }
}

export function getDriversLicense(type: DriverLicensesType) {
  switch (type) {
    case DriverLicensesType.LK:
      return DriverLicense.LK;
    case DriverLicensesType.AM:
      return DriverLicense.AM;
    case DriverLicensesType.A1:
      return DriverLicense.A1;
    case DriverLicensesType.A2:
      return DriverLicense.A2;
    case DriverLicensesType.A:
      return DriverLicense.A;
    case DriverLicensesType.B:
      return DriverLicense.B;
    case DriverLicensesType.BE:
      return DriverLicense.BE;
    case DriverLicensesType.C1:
      return DriverLicense.C1;
    case DriverLicensesType.C1E:
      return DriverLicense.C1E;
    case DriverLicensesType.C:
      return DriverLicense.C;
    case DriverLicensesType.CE:
      return DriverLicense.CE;
    case DriverLicensesType.D1:
      return DriverLicense.D1;
    case DriverLicensesType.D1E:
      return DriverLicense.D1E;
    case DriverLicensesType.D:
      return DriverLicense.D;
    case DriverLicensesType.DE:
      return DriverLicense.DE;
    case DriverLicensesType.TM:
      return DriverLicense.TM;
    default:
      throw new Error('Kørtkort ikke genkendt');
  }
}
